import React, { Component } from "react";
import TopDrawer from "../topDrawer/topDrawer";
import Styles from "./styles/topMenuStyles";
import Icon from "../pageElements/icon";

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuData: [],
      open: false,
    };
    //this.escFunction = this.escFunction.bind(this);
  }

  escFunction = (event) => {
    if (event.keyCode === 27 && this.state.open) {
      this.setState((state) => ({ open: !state.open }));
      this.closeDrawer();
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  closeDrawer() {
    const elem = document.getElementById("topDrawerMenu");
    if (document.getElementById("vidheaderVideo") !== null) {
      document.getElementById("vidheaderVideo").play();
    }
    const id = setInterval(frame, 0.005);
    let pos = 0;
    const button = document.getElementById("topDrawerToggle");
    const modal = document.getElementById("modalTop");
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
    modal.style.position = "fixed";
    modal.style.top = "-1500px";
    modal.style.right = "0";
    modal.style.bottom = "0";
    modal.style.left = "0";
    modal.style.background = "#fff";
    modal.style.zIndex = "99990";
    modal.style.opacity = "0";
    modal.style.WebkitTransition = "opacity 400ms ease-in";
    modal.style.MozTransition = "opacity 400ms ease-in";
    modal.style.transition = "opacity 400ms ease-in";
    modal.style.pointerEvents = "none";

    function frame() {
      if (pos === -650) {
        clearInterval(id);
        button.classList.add("closed");
        button.classList.remove("open");
      } else {
        pos -= 5;
        elem.style.top = pos + "px";
        elem.style.position = "absolute";
        elem.style.width = "100%";
        elem.style.overflow = "hidden";
        elem.style.zIndex = "999999";
        elem.style.backgroundColor = "#fff";
      }
    }
  }
  tabIndexToggler() {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const tabIndex = this.state.open ? "-1" : "0";
    const menuTabIndex = this.state.open ? "0" : "-1";
    for (let i = 0; i < alphabet.length; i++) {
      document.getElementById(
        alphabet[i]
      ).firstElementChild.tabIndex = tabIndex;
    }
    document.getElementById("search").tabIndex = tabIndex;
    document.getElementById("q_as").tabIndex = tabIndex;
    document.getElementById("myuvm").tabIndex = menuTabIndex;
  }

  handleDrawerToggle = () => {
    this.tabIndexToggler();
    this.setState((state) => ({ open: !state.open }));

    if (!this.state.open) {
      const elem = document.getElementById("topDrawerMenu");
      if (document.getElementById("vidheaderVideo") !== null) {
        document.getElementById("vidheaderVideo").pause();
      }

      const modal = document.getElementById("modalTop");
      let pos = -650;
      const id = setInterval(frame, 0.005);
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      modal.style.position = "fixed";
      modal.style.top = "0px";
      modal.style.right = "0";
      modal.style.bottom = "0";
      modal.style.left = "0";
      modal.style.background = "#fff";
      modal.style.zIndex = "99990";
      modal.style.opacity = ".9";
      modal.style.WebkitTransition = "opacity 400ms ease-in";
      modal.style.MozTransition = "opacity 400ms ease-in";
      modal.style.transition = "opacity 400ms ease-in";
      modal.style.pointerEvents = "all";

      function frame() {
        if (pos === 135) {
          clearInterval(id);
          const button = document.getElementById("topDrawerToggle");
          button.classList.add("open");
          button.classList.remove("closed");
        } else {
          pos += 5;
          elem.style.top = pos + "px";
          elem.style.position = "fixed";
          elem.style.zIndex = "999999";
          elem.style.opacity = 1;
          elem.style.height = window.innerWidth > 899 ? "300px" : "auto";
          elem.style.width = "100vw";
          elem.style.left = "0";
          elem.style.backgroundColor = "#fff";
        }
      }
    } else {
      this.closeDrawer();
    }
  };

  render() {
    return (
      <nav className="threeButtonContainer" style={Styles.threeBCStyles}>
        <ul
          id="topnav"
          className="subsite_mainframe"
          style={{ ...Styles.ulStyles, zIndex: "1000" }}
        >
          <li className="apply" style={Styles.liStyles}>
            <a
              id="topMenuApply"
              tabIndex="0"
              href="http://www.uvm.edu/focus/"
              style={Styles.aStyles}
            >
              Apply
            </a>
          </li>
          <li style={Styles.liStyles}>
            <button
              tabIndex="0"
              id="topDrawerToggle"
              className="topToggle closed"
              onClick={this.handleDrawerToggle}
              style={Styles.buttonStyles}
            >
              Search
            </button>
          </li>
          <li className="myuvm" style={{ ...Styles.liStyles }}>
            <a
              id="myuvm"
              tabIndex="0"
              style={Styles.aStyles}
              href="https://myuvm.uvm.edu/"
              title="Log into the myUVM portal"
            >
              myUVM
            </a>
          </li>
        </ul>
        <TopDrawer open={this.state.open} />
        <div
          onClick={this.handleDrawerToggle}
          id="modalTop"
          className="modalDialog"
          style={{ ...Styles.modal }}
        >
          <Icon
            type="Cir"
            iconStyles={{ width: "45px" }}
            style={{
              position: "absolute",
              zIndex: "9999",
              top: "64px",
              right: "44px",
            }}
          />
        </div>
      </nav>
    );
  }
}

export default TopMenu;
